<!-----------------fillering------------------->
<div class="card-body">
    <div class="row">
    <div class="col-md-6">

        <div class="form-group">
            <label>Select Usertype</label>
        
            <select  class="form-control select2 select2-hidden-accessible size" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true"  #selectRole (change)='RoleSelected(selectRole.value)' >
                <option selected="selected" [value]="0">ALL</option>
<option *ngFor="let u of userTypes" [value]="u.name">{{ u.name }}</option>
            </select>
            
            <span class="dropdown-wrapper" aria-hidden="true"></span>
        </div>
  
    <div class="form-group">
        <label>Select Department</label>
    
        <select  #teams (change)="onSelected(teams.value)" class="form-control select2 select2-hidden-accessible size" data-select2-id="1" tabindex="-1" aria-hidden="true">
        <option selected="selected" data-select2-id="1" [value]=0 >ALL</option>
        <option *ngFor="let d of department" data-select2-id="2" [value]="d.department_id">{{d.department_name}}</option>
       
        <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
        </select>
        
        <span class="dropdown-wrapper" aria-hidden="true"></span>
    </div>


    </div>

    <div class="col-md-6">
    <div class="form-group">

        <div class="form-group">
            <label>Select Month</label>

            <input type="month" id="test" name="test"  class="form-control form-control-lg size" [(ngModel)]="Date"  (change)="onSelecteDate()">
        
            <!-- <select  #teams (change)="onSelected(teams.value)" class="form-control select2 select2-hidden-accessible size" data-select2-id="1" tabindex="-1" aria-hidden="true">
            <option selected="selected" data-select2-id="1">ALL</option>
            <option *ngFor="let d of department" data-select2-id="2">{{d.department_name}}</option>
           
            <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
            </select>
            
            <span class="dropdown-wrapper" aria-hidden="true"></span> -->
        </div>
   
        <div class="form-group">
            <label>Search Employee</label>
           
            <div class="input-group">
                <input  type="search" class="form-control form-control-lg " placeholder="Search Employee" id="search" name="search" [(ngModel)]="search" (ngModelChange)="Search();">
                <div class="input-group-append">
                <button type="submit" class="btn btn-lg btn-default " (click)="Search();">
                <i class="fa fa-search"></i>
                </button>
                </div>
            </div>
        </div>
    </div>
   
    </div>
  


   
<!---------------------------------new ui---------------------------------------------------->
 

    <section class="content-header ">
         <div class="row mb-2 ">
        <div class="col-sm-6">     
        <h1>Employees</h1>
    
        </div>
        <div class="col-sm-6"> 
            <div style="margin-left: 90%;">
                <img class="excel-button" src="https://cdn-icons-png.flaticon.com/128/732/732220.png" width="35"
                    height="35" (click)="excelExport()">
            </div>
        </div>
        </div>

        </section>

        
    <!--------------loader-------------------------->
    <div *ngIf=loaderShown class="loader"></div>
    <!----------------------------------------------->
        
    <section class="content">
    
    <div class="card" *ngIf=CardShown>
    <div class="card-header">
    <!--
    <h3 class="card-title Title">Employee Listing</h3>
    -->
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects"  id="employee_kpi">
    <thead>
    <tr>
   

    <th >
    Name
    </th>

    <th >
   Monthly KPI
    </th>

    <th>
    Attendance
    </th>
    <th>
    RFR
    </th>

    <th>
    Visit plan
    </th>

    <th >
    Visit
    </th>
    <th >
    Unposted Invoices
    </th>
    <th >
        Pending Invoices
    </th>
    
     
    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
        {{c.employee_name}}
    </a>
    </td>
    
    <td *ngIf="c.kpi_score.hasOwnProperty('total')">
        {{c.kpi_score.total}}
    </td>

    <td *ngIf="!c.kpi_score.hasOwnProperty('total')">
        100
    </td>
<!------------------------------------------------------------------------------->
     <td  *ngIf="c.kpi_score.hasOwnProperty('employee_attendance_point')">
        {{c.kpi_score.employee_attendance_point}}
    </td> 
 
    <td  *ngIf="!c.kpi_score.hasOwnProperty('employee_attendance_point')">
       0
    </td> 
<!------------------------------------------------------------------------------->
    <td  *ngIf="c.kpi_score.hasOwnProperty('rfr_over_due_count')">
        {{c.kpi_score.rfr_over_due_count}}
    </td>
    <td  *ngIf="!c.kpi_score.hasOwnProperty('rfr_over_due_count')">
        0
     </td> 
<!------------------------------------------------------------------------------->
    <td  *ngIf="c.kpi_score.hasOwnProperty('kpi_score.visitPlanWaitingpoint')">
        {{c.kpi_score.visitPlanWaitingpoint}}
    </td>
    <td  *ngIf="!c.kpi_score.hasOwnProperty('kpi_score.visitPlanWaitingpoint')">
        0
     </td> 
<!------------------------------------------------------------------------------->
    <td  *ngIf="c.kpi_score.hasOwnProperty('visitplanApprovedPoint')">
        {{c.kpi_score.visitplanApprovedPoint}}
    </td>
    <td  *ngIf="!c.kpi_score.hasOwnProperty('visitplanApprovedPoint')">
        0
     </td> 
    <td  *ngIf="c.kpi_score.hasOwnProperty('Unposted_invoices')">
        {{c.kpi_score.Unposted_invoices}}
    </td>
    <td  *ngIf="!c.kpi_score.hasOwnProperty('Unposted_invoices')">
        0
     </td> 
    <td  *ngIf="c.kpi_score.hasOwnProperty('hardcopy_not_received_invoices')">
        {{c.kpi_score.hardcopy_not_received_invoices}}
    </td>
    <td  *ngIf="!c.kpi_score.hasOwnProperty('hardcopy_not_received_invoices')">
        0
     </td> 
<!-------------------------------------------------------------------------------> 
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm"  routerLink="/admin/employee-kpi-details" [queryParams]="{id:c.employee_id , userType : c.user_type}" >
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <a class="btn btn-info btn-sm left" (click)='EditEmployee(c.employee_id,c.user_type);'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    <!--
    <a class="btn btn-danger btn-sm" href="#">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    -->
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
    
   
<!-------------------------------paging--------------------------------------------------------->
<!-- <div *ngIf=CardShown>
<div class="row">
    <div class="col-sm-12 col-md-5">
    <div class="col-sm-12 col-md-7"><div class="dataTables_paginate paging_simple_numbers " id="example2_paginate">
    </div></div></div></div>


    <div class="col-sm-12 col-md-7">
        <div class="dataTables_paginate paging_simple_numbers" id="example2_paginate">
            <ul class="pagination ">
                <li class="paginate_button page-item previous" id="example2_previous">
                <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link">Previous</a></li>

                <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link">{{count+1}}</a></li>
               
                <li class="paginate_button page-item next" id="example2_next">
                <a (click)="clicks_next()" aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
            </ul>
        </div>
    
    </div>
 
</div> -->
      

